import { ref } from "vue";
import { defineStore } from "pinia";
import { useNavigationStore } from "@/stores/navigation";
import { getDashboards, storeDashboard, updateDashboard, archiveDashboard } from "@/services/DashboardService";

// import { getError } from "@/utils/helpers";

export const useDashboardStore = defineStore('dashboards', () => {

    const navigationStore = useNavigationStore();

    const dashboards = ref([]);
    const activeDashboard = ref(null)

    function setActiveDashboard(dashboard){
        activeDashboard.value = dashboard
    }

    async function setDashboards(){
        dashboards.value = await getDashboards();
    }

    async function addDashboard(payload){
        let dashboard = await storeDashboard(payload)

        dashboards.value.push(dashboard)

        let node = createNode(dashboard)
        navigationStore.addNode(node, 'dashboards')
    }

    async function editDashboard(payload){
        updateDashboard(activeDashboard.value.id, payload)
    }

    async function removeDashboard(dashboard_id, dashboardIndex){
        await archiveDashboard(dashboard_id)

        dashboards.value.splice(dashboardIndex, 1)

        //navigationStore.removeNode(dashboard_id)

        navigationStore.removeNode(dashboard_id, 'dashboard')
    }

    function createNode(dashboard){
        let node = {
            id: dashboard.id,
            title: dashboard.title,
            icon: 'si si-grid',
            route: 'dashboard',
            params: { dashboard_id: dashboard.id}
        }

        return node
    }

    async function createDashboardNavigationNodes(){
        dashboards.value.forEach(dashboard => {
            let node = createNode(dashboard)
            navigationStore.addNode(node, 'dashboards')
        })
    }

    function $reset() {
        dashboards.value = []
        activeDashboard.value = null
    }

    return {
        dashboards, 
        activeDashboard,
        setActiveDashboard,
        setDashboards,
        addDashboard,
        editDashboard,
        removeDashboard,
        createNode,
        createDashboardNavigationNodes,
        $reset
    }
});